import _ from 'lodash';
import angular from 'angular';
import * as colors from '../../../constants/colors';

const defaultColorScheme = {
    buttons: {
        primary: {
            textColor: colors.white,
            backgroundColor: colors.royalblue,
            borderColor: colors.royalblue,
        },
        light: {
            textColor: colors.royalblue,
            backgroundColor: colors.white,
            borderColor: colors.royalblue,
        },
        linkedIn: {
            textColor: colors.linkedinBrandColor,
            backgroundColor: colors.white,
            borderColor: colors.linkedinBrandColor,
        },
    },
    links: {
        primary: {
            textColor: colors.royalblue,
        },
    },
};

const TFT_BUTTON = 'TFT-BUTTON';

export const themedButton = RouteService => ({
    restrict: 'A',
    async link(scope, element, attrs) {
        const colorSchemeSettings = await RouteService.getSystemDefaultsAsync('colorSchemeSettings');
        const buttonsColorScheme = _.get(colorSchemeSettings, 'buttons', defaultColorScheme.buttons);

        const tagName = element[0].tagName;
        if (tagName === TFT_BUTTON) {
            element.addClass('themed-button');
            element.children().eq(0).css({
                'border-color': colorSchemeSettings?.tftPrimaryColor || buttonsColorScheme.primary.borderColor,
                'background-color': colorSchemeSettings?.tftPrimaryColor || buttonsColorScheme.primary.backgroundColor,
                color: buttonsColorScheme.primary.textColor,
            });
        } else {
            element.addClass('themed-button');
            element.css({
                'border-color': colorSchemeSettings?.tftPrimaryColor || buttonsColorScheme.primary.borderColor,
                'background-color': colorSchemeSettings?.tftPrimaryColor || buttonsColorScheme.primary.backgroundColor,
                color: buttonsColorScheme.primary.textColor,
            });
        }
    },
});

export const themedButtonLight = RouteService => ({
    restrict: 'A',
    async link(scope, element) {
        const colorSchemeSettings = await RouteService.getSystemDefaultsAsync('colorSchemeSettings');
        const buttonsColorScheme = _.get(colorSchemeSettings, 'buttons', defaultColorScheme.buttons);

        const tagName = element[0].tagName;
        if (tagName === TFT_BUTTON) {
            element.addClass('themed-button');
            element.children().eq(0).css({
                'border-color': buttonsColorScheme.light.borderColor,
                'background-color': buttonsColorScheme.light.backgroundColor,
                color: colorSchemeSettings?.tftPrimaryColor || buttonsColorScheme.light.textColor,
            });
        } else {
            element.addClass('themed-button');
            element.css({
                'border-color': buttonsColorScheme.light.borderColor,
                'background-color': buttonsColorScheme.light.backgroundColor,
                color: colorSchemeSettings?.tftPrimaryColor || buttonsColorScheme.light.textColor,
            });
        }
    },
});

export const themedButtonLightInverted = RouteService => ({
    restrict: 'A',
    async link(scope, element) {
        const colorSchemeSettings = await RouteService.getSystemDefaultsAsync('colorSchemeSettings');
        const buttonsColorScheme = _.get(colorSchemeSettings, 'buttons', defaultColorScheme.buttons);

        const tagName = element[0].tagName;
        if (tagName === TFT_BUTTON) {
            element.addClass('themed-button');
            element.children().eq(0).css({
                'border-color': buttonsColorScheme.light.textColor,
                'background-color': buttonsColorScheme.light.backgroundColor,
                color: buttonsColorScheme.light.borderColor,
            });
        } else {
            element.addClass('themed-button');
            element.css({
                'border-color': buttonsColorScheme.light.textColor,
                'background-color': buttonsColorScheme.light.backgroundColor,
                color: buttonsColorScheme.light.borderColor,
            });
        }
    },
});

export const themedButtonLightInners = RouteService => ({
    restrict: 'A',
    async link(scope, element) {
        const colorSchemeSettings = await RouteService.getSystemDefaultsAsync('colorSchemeSettings');
        const buttonsColorScheme = _.get(colorSchemeSettings, 'buttons', defaultColorScheme.buttons);

        element.addClass('themed-button-inners');
        element.css({
            'background-color': buttonsColorScheme.light.textColor,
            color: colorSchemeSettings?.tftPrimaryColor || buttonsColorScheme.light.textColor,
        });
    },
});

export const themedButtonLightInnersSvg = RouteService => ({
    restrict: 'A',
    async link(scope, element) {
        const colorSchemeSettings = await RouteService.getSystemDefaultsAsync('colorSchemeSettings');
        const buttonsColorScheme = _.get(colorSchemeSettings, 'buttons', defaultColorScheme.buttons);

        element.addClass('themed-button-inners-svg');
        element.css({
            color: buttonsColorScheme.light.textColor,
            fill: buttonsColorScheme.light.textColor,
            stroke: buttonsColorScheme.light.textColor,
            'stroke-width': '0',
        });
    },
});

export const themedLink = RouteService => ({
    restrict: 'A',
    async link(scope, element, attrs) {
        const colorSchemeSettings = await RouteService.getSystemDefaultsAsync('colorSchemeSettings');
        const linksColorScheme = _.get(colorSchemeSettings, 'links', defaultColorScheme.links);

        const tagName = element[0].tagName;
        if (tagName === TFT_BUTTON) {
            element.addClass('themed-button');
            element.children().eq(0).css({
                color: colorSchemeSettings?.tftPrimaryColor || linksColorScheme.primary.textColor,
            });
        } else {
            element.addClass('themed-link');
            element.css({
                color: colorSchemeSettings?.tftPrimaryColor || linksColorScheme.primary.textColor,
            });
        }
    },
});

export const themedHoveredLink = RouteService => ({
    restrict: 'A',
    async link(scope, element, attrs) {
        const colorSchemeSettings = await RouteService.getSystemDefaultsAsync('colorSchemeSettings');
        const linksColorScheme = _.get(colorSchemeSettings, 'links', defaultColorScheme.links);

        const tagName = element[0].tagName;
        if (tagName === TFT_BUTTON) {
            element.addClass('themed-hovered-button');
            element.children().eq(0).css({
                color: colorSchemeSettings?.tftPrimaryColor || linksColorScheme.primary.textColor,
            });
        } else {
            element.addClass('themed-hovered-link');
            element.bind('mouseenter', function(event) {
                element.css({
                    color: colorSchemeSettings?.tftPrimaryColor || linksColorScheme.primary.textColor,
                });
            });
            element.bind('mouseleave', function(event) {
                element.css({
                    color: '',
                });
            });
        }
    },
});

angular
    .module('TALENYA-FE')
    .directive('themedLinkPrimary', themedLink)
    .directive('themedHoveredLinkPrimary', themedHoveredLink)
    .directive('themedButtonPrimary', themedButton)
    .directive('themedButtonLight', themedButtonLight)
    .directive('themedButtonLightInverted', themedButtonLightInverted)
    .directive('themedButtonLightInners', themedButtonLightInners)
    .directive('themedButtonLightInnersSvg', themedButtonLightInnersSvg);

